import { Box, TextInput } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { CollapsibleCard } from '@flecto/ui'

import { FormImages } from '../FormStoreSettings/FormImages'
import { FormSection } from '../FormStoreSettings/FormSection'
import { useFormContext } from '../FormStoreSettings/FormStoreSettings'

export function CardStoreGeneralInfo() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const form = useFormContext()

  return (
    <FormSection>
      <CollapsibleCard opened>
        <CollapsibleCard.Title>
          {t('section_general.title')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          <Box mr='sm'>{t('section_general.description')}</Box>
        </CollapsibleCard.Description>
        <CollapsibleCard.Content>
          <TextInput
            mt='sm'
            key={form.key('name')}
            label={t('section_general.name')}
            placeholder={t('section_general.name_placeholder')}
            withAsterisk
            {...form.getInputProps('name')}
          />
          <TextInput
            key={form.key('slogan')}
            mt='lg'
            label={t('section_general.slogan')}
            placeholder={t('section_general.slogan_placeholder')}
            withAsterisk
            {...form.getInputProps('slogan')}
          />
        </CollapsibleCard.Content>
      </CollapsibleCard>
      <FormImages images={[require('./image.jpeg')]} />
    </FormSection>
  )
}
